import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, finalize, first, map, takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import constants from 'src/constant.json';
import { environment } from 'src/environments/environment';
import { UserState } from '../state/user.state';
import { QuestionnaireService } from './questionnaire.service';

@Injectable({
  providedIn: 'root',
})
export class WalkthroughService {
  dashboardCountRedirection: any = constants.DEFAULT_DASHBOARD_REDIRECTION;

  constructor(
    private userState: UserState,
    private http: HttpClient,
    private appState: AppState,
    private questionnaireService: QuestionnaireService
  ) {}

  private walkthroughUpdatingMap: { [key: string]: boolean } = {};
  onDestroyNotifier$ = new Subject();

  isWalkthroughDone(module: string): Observable<boolean> {
    return this.userState.userDetail$.pipe(
      filter((res) => res !== null),
      first(),
      map((res) => {
        const user = res.user_profile;
        return user?.walkthrough?.[module];
        // return false;
      })
    );
  }

  handleWalkthrough(module: string): void {
    if (this.walkthroughUpdatingMap[module]) return;

    this.userState.userDetail$
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        filter((res) => res !== null),
        first()
      )
      .subscribe((res) => {
        if (!res) return;

        let user = res.user_profile;
        user.workPlace = res.workPlace;
        const existingWalkthrough = user?.walkthrough || {};
        const updatedWalkthrough = this.buildWalkthroughObject(existingWalkthrough, module);
        this.walkthroughUpdatingMap[module] = true;
        const payload = {
          userProfile: {
            ...user,
            walkthrough: updatedWalkthrough,
          },
        };
        this.http
          .post(environment.prospektrBackendBaseURL + constants.API.updateUser, payload)
          .pipe(
            finalize(() => {
              //  observer.complete();
            })
          )
          .subscribe(
            (res: any) => {
              if (res && res.message && res.status.toLowerCase() == 'success') {
                this.userState.userDetails.user_profile = payload.userProfile;
              }

              if (this.appState?.companyInfoValue?.alias != 'valuetest') {
                this.questionnaireService.triggerQuestionnaire();
              }
            },
            (err) => {
              // observer.next({
              //   message: err.error && err.error.message ? err.error.message : 'Error occurred',
              //   status: false,
              // });
            }
          );
        //  });
      });
  }

  private buildWalkthroughObject(existing: any = {}, module: string): any {
    const fullWalkthrough = {};

    Object.values(constants.WALKTHROUGH_KEYS).forEach((key: string) => {
      fullWalkthrough[key] = key === module ? true : existing[key] ?? false;
    });

    return fullWalkthrough;
  }
}
